import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOngedierteMelden = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      stroke="#F8BADD"
      strokeLinecap="round"
      strokeMiterlimit={10}
      d="M30.41 25.5h3.3c2.28 0 2.04 1.77 2.04 1.77s.12 1.77-1.89 1.77H22.38"
    />
    <path
      fill="#F170B8"
      d="M6 26h28c1.29-5.49-.82-11-8-11C15 15 6 26 6 26"
    />
    <path
      fill="#F170B8"
      d="M12.5 23a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#F8BADD"
      d="M12.5 21.88a2.38 2.38 0 1 0 0-4.76 2.38 2.38 0 0 0 0 4.76"
    />
    <path
      fill="#F170B8"
      d="M7 25c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1h2"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="M25.65 19.47a3.271 3.271 0 0 0 0 6.54h3.38"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOngedierteMelden);

export default ForwardRef;
